module.exports = __webpack_public_path__ + "static/media/ooDadi.54eaf120.jpg";